import { Loader } from '@/app/components/search/components/EvolutionCard/Loaders/styled.ts';
import React from 'react';

type PriceLoaderProps = {
  isOverlay: boolean;
  isMobile: boolean;
};

const PriceLoader = ({ isOverlay, isMobile }: PriceLoaderProps) => {
  if (isOverlay) {
    return (
      <>
        <Loader elWidth={93} elHeight={22} style={{ alignSelf: 'self-start', marginBottom: 4 }} />
        <Loader elWidth={133} elHeight={16} style={{ alignSelf: 'self-start', marginBottom: 4 }} />
        <Loader elWidth={118} elHeight={16} style={{ alignSelf: 'self-start', marginBottom: 8 }} />
      </>
    );
  }

  if (isMobile) {
    return (
      <>
        <Loader elWidth={93} elHeight={22} style={{ alignSelf: 'self-start', marginBottom: 4, marginTop: 16 }} />
        <Loader elWidth={133} elHeight={16} style={{ alignSelf: 'self-start', marginBottom: 4 }} />
        <Loader elWidth={118} elHeight={16} style={{ alignSelf: 'self-start', marginBottom: 8 }} />
        <Loader elWidth={'100%'} elHeight={48} />
      </>
    );
  }

  return (
    <>
      <Loader elWidth={93} elHeight={22} style={{ marginBottom: 4 }} />
      <Loader elWidth={133} elHeight={16} style={{ marginBottom: 4 }} />
      <Loader elWidth={118} elHeight={16} style={{ marginBottom: 8 }} />
      <Loader elWidth={'100%'} elHeight={48} />
    </>
  );
};

export default PriceLoader;
